import { useNavigate } from 'react-router-dom';
import { lookbookPhotos } from '@/mocks/lookbook';

const heightMap: Record<string, string> = {
  tall: 'row-span-2',
  medium: 'row-span-1',
  short: 'row-span-1',
};

const imgHeightMap: Record<string, string> = {
  tall: 'h-[520px]',
  medium: 'h-[260px]',
  short: 'h-[220px]',
};

export default function Lookbook() {
  const navigate = useNavigate();

  return (
    <section id="lookbook" className="bg-white py-20 md:py-28 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">

        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block border border-[#C49A3E] text-[#C49A3E] text-sm font-sans tracking-widest px-4 py-1.5 rounded-full mb-5 font-medium">
            STYLE LOOKBOOK
          </span>
          <h2 className="font-serif text-[1.5rem] md:text-[2.125rem] text-[#2C2118] font-semibold leading-[1.4] mb-4">
            穿搭靈感・實穿分享
          </h2>
          <p className="font-sans text-[1.1875rem] text-[#2C2118]/60 leading-[1.75] max-w-lg mx-auto">
            從職場到日常，每一個 Look 都是真實的穿搭提案，找到屬於妳的日常風格
          </p>
        </div>

        {/* Masonry Grid */}
        <div className="columns-2 md:columns-3 lg:columns-4 gap-4 space-y-4">
          {lookbookPhotos.map((photo) => (
            <div
              key={photo.id}
              className="break-inside-avoid group relative overflow-hidden rounded-xl cursor-pointer"
              onClick={() => navigate('/style-guide')}
            >
              <div className={`w-full overflow-hidden ${imgHeightMap[photo.height]}`}>
                <img
                  src={photo.image}
                  alt={photo.tag}
                  title={`${photo.tag} - 穿搭靈感`}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
              </div>

              {/* Hover Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-4">
                <span className="inline-block self-start font-sans text-xs text-white font-medium tracking-wider bg-[#C49A3E] px-3 py-1 rounded-full mb-2">
                  {photo.tag}
                </span>
                <p className="font-sans text-sm text-white/90">查看穿搭指南 &rarr;</p>
              </div>

              {/* Default Tag Badge */}
              <span className="absolute top-3 left-3 font-sans text-xs text-[#2C2118] font-medium tracking-wide bg-white/90 px-2.5 py-1 rounded-full group-hover:opacity-0 transition-opacity duration-300">
                {photo.tag}
              </span>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-14">
          <button
            onClick={() => navigate('/style-guide')}
            className="whitespace-nowrap font-sans text-[1.0625rem] font-medium bg-[#2C2118] text-white px-10 py-3.5 rounded-full hover:bg-[#C49A3E] transition-all duration-300 cursor-pointer"
          >
            探索完整穿搭指南
          </button>
        </div>

      </div>
    </section>
  );
}
